import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchFailedTransactions, fetchListClubs } from "@/api/merchant/request.get";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { AddImg } from "@/shared/components/common/icons";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useLocation, useNavigate } from "react-router";
import BoxKit from "@/shared/components/kit/box";
import { CircularProgress } from "@mui/material";
import AlertDialog from "@/shared/components/kit/modal";
import { FailedTransaction } from "@/types/api/merchant/merchant.type";
import { useState, useRef } from "react";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import TableWallet from "@/modules/user/components/walletReports/table"; // Updated import path
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { deleteFailedTransactions } from "@/api/merchant/request.delete"; // Add delete API

const ContentCards = () => {
  const location = useLocation();
  const path = location.key;
  const [failedTxData, setFailedTxData] = useState<any[]>([]);
  const [isOpenModalFailedTransactions, setIsOpenModalFailedTransactions] = useState(false);
  const [selectedClubId, setSelectedClubId] = useState<string>("");
  const deletingIdRef = useRef<string | number | null>(null);
  
  const tableHeaderConfig = [
    { id: "id", title: "شناسه" },
    { id: "nid", title: "کد ملی" },
    { id: "first_name", title: "نام" },
    { id: "last_name", title: "نام خانوادگی" },
    { id: "card_number", title: "شماره کارت" },
    { id: "price", title: "مبلغ" },
    { id: "error_message", title: "پیام خطا" },
    { id: "created_at", title: "زمان ساخت" },
    { id: "type", title: "نوع" },
    { id: "action", title: "حذف" } // Added action column
  ];

  const { data, isLoading } = useQuery({
    queryKey: ["listClubs-data", path],
    queryFn: fetchListClubs,
  });

  const { mutate: fetchFailedTx, isPending } = useMutation({
    mutationFn: fetchFailedTransactions,
    onSuccess: (res) => {
      const formattedData = res.data.map((item: FailedTransaction) => ({
        ...item,
        created_at: new Date(item.created_at).toLocaleString('fa-IR')
      }));
      setFailedTxData(formattedData);
      setIsOpenModalFailedTransactions(true);
    },
    onError: (error: AxiosError<{ message: string }>) => {
      setIsOpenModalFailedTransactions(true);
    },
  });

  // Delete mutation
  const { mutate: deleteFailedTx, isPending: isDeleting } = useMutation({
    mutationFn: deleteFailedTransactions,
    onSuccess: () => {
      toast.success("تراکنش با موفقیت حذف شد");
      // Refetch after deletion
      fetchFailedTx({ clubId: selectedClubId });
      setFailedTxData(prev => prev.filter(item => item.id !== deletingIdRef.current));
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در حذف تراکنش");
    },
  });

  const navigate = useNavigate();

  const handleFailedTransactionsClick = (clubId: string) => {
    setSelectedClubId(clubId);
    setIsOpenModalFailedTransactions(true);
    fetchFailedTx({ clubId });
  };

  return (
    <>
      <StackKit direction={"row"} flexWrap="wrap" gap={2} justifyContent="center" position={'relative'}>
        {isLoading ?
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, borderRadius: '8px' }}>
            <CircularProgress sx={{ color: '#fff' }} />
          </div>
          : data?.map((item) => {
            return (
              <BoxKit key={item.id}>
                <CardKit sx={{ bgcolor: "#2C2C2C", width: "265px", margin: "0 !important", position: "relative" }}>
                  <StackKit 
                    sx={{ 
                      position: "absolute", 
                      top: 8, 
                      right: 8, 
                      zIndex: 1,
                      cursor: "pointer",
                      bgcolor: "rgba(0,0,0,0.6)",
                      borderRadius: "50%",
                      padding: "4px",
                      '&:hover': {
                        bgcolor: "rgba(0,0,0,0.8)"
                      }
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFailedTransactionsClick(item.id.toString());
                    }}
                  >
                    <ErrorOutlineOutlinedIcon sx={{ color: "#ff6b6b", fontSize: "24px" }} />
                  </StackKit>
                  
                  <StackKit justifyContent={"center"} alignItems={"center"}>
                    <StackKit justifyContent={"center"} alignItems={"center"} sx={{ bgcolor: "#A1A1A1", height: "229px", borderRadius: "8px", padding: "20px", width: "100%", overflow: "hidden" }}>
                      <img src={item.image} alt={item.image} />
                    </StackKit>
                    <StackKit direction={"row"} sx={{ width: "100%" }} justifyContent={"space-between"}>
                      <div>تعداد کاربران: {item.count} نفر</div>
                      <GroupOutlinedIcon style={{ color: "#fff" }} />
                    </StackKit>
                    <StackKit direction={"row"} sx={{ width: "100%" }} justifyContent={"space-between"}>
                      <div>{item.title}</div>
                      <MoreVertOutlinedIcon style={{ color: "#fff", cursor: "pointer" }} onClick={() => navigate(`/customer-my-organization/${item.id}`)} />
                    </StackKit>
                  </StackKit>
                </CardKit>
              </BoxKit>
            );
          })}
        <BoxKit>
          <CardKit sx={{ bgcolor: "#2C2C2C", height: '100%' }}>
            <StackKit justifyContent={"center"} alignItems={"center"}>
              <StackKit justifyContent={"center"} alignItems={"center"} sx={{ bgcolor: "#A1A1A1", height: "229px", borderRadius: "8px", padding: "20px", width: "100%", overflow: "hidden" }}>
                <AddImg />
              </StackKit>
              <StackKit direction={"row"} justifyContent={"space-between"} alignItems={"center"} sx={{ width: "100%", border: "1px solid #5A5A5A", borderRadius: "8px", height: "38px", padding: "0 15px", cursor: "pointer" }}
                onClick={() => navigate("/customer-organization")}>
                <TypoGraphyKit variant="body1">
                  افزودن سازمان
                </TypoGraphyKit>
                <AddOutlinedIcon style={{ color: "#fff" }} />
              </StackKit>
            </StackKit>
          </CardKit>
        </BoxKit>
      </StackKit>
      
      <AlertDialog
        agreeText="بستن"
        isHeader
        open={isOpenModalFailedTransactions}
        onClose={() => {
          setIsOpenModalFailedTransactions(false);
          setFailedTxData([]);
          setSelectedClubId("");
        }}
        header={<TypoGraphyKit variant="h6">تراکنش‌‌های ناموفق</TypoGraphyKit>}
        fullScreen={true}
      >
        {isPending || isDeleting ? (
          <StackKit sx={{ height: '100%', width: '100%' }} justifyContent="center" alignItems="center">
            <CircularProgress sx={{ color: "#fff" }} />
          </StackKit>
        ) : failedTxData.length > 0 ? (
<AlertDialog
  agreeText="بستن"
  isHeader
  open={isOpenModalFailedTransactions}
  onClose={() => {
    setIsOpenModalFailedTransactions(false);
    setFailedTxData([]);
    setSelectedClubId("");
  }}
  header={<div style={{ fontSize: '1.25rem', fontWeight: 500 }}>تراکنش‌‌های ناموفق</div>}
  fullScreen={true}
/>
        ) : (
          <TypoGraphyKit display={'flex'} justifyContent={'center'} alignItems={'center'} width={'100%'} height={'100%'} variant="body1">
            هیچ تراکنش ناموفقی برای این سازمان یافت نشد.
          </TypoGraphyKit>
        )}
      </AlertDialog>
    </>
  );
};

export default ContentCards;